import { render } from "./Section6.vue?vue&type=template&id=0e392b78&scoped=true"
import script from "./Section6.vue?vue&type=script&lang=js"
export * from "./Section6.vue?vue&type=script&lang=js"

import "./Section6.vue?vue&type=style&index=0&id=0e392b78&lang=scss&scoped=true"

import exportComponent from "/Users/bruno/Documents/projects/pixeon-c/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e392b78"]])

export default __exports__